import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import PropTypes from "prop-types";
import { getClassNameFactory } from "../../../../utilities/classNames";
import classNames from "classnames";
import ChevronDown from "@dcl/icons/esm/ui/chevron-down";
import UiCross from "@dcl/icons/esm/ui/cross";
import AutosizeInput from "react-input-autosize";
import MultiDownshift from "../MultiDownshift";
import { getItems } from "./utilities";

var MultiSelectDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiSelectDropdown, _React$Component);

  var _super = _createSuper(MultiSelectDropdown);

  function MultiSelectDropdown() {
    var _this;

    _classCallCheck(this, MultiSelectDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "input", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasFocus: false
    });

    _defineProperty(_assertThisInitialized(_this), "getClassName", getClassNameFactory(MultiSelectDropdown.displayName));

    _defineProperty(_assertThisInitialized(_this), "itemToString", function (item) {
      return item ? item.value : "";
    });

    return _this;
  }

  _createClass(MultiSelectDropdown, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleChange = _this$props.handleChange,
          name = _this$props.name,
          noOptionsMessage = _this$props.noOptionsMessage,
          options = _this$props.options,
          placeholder = _this$props.placeholder;
      var hasFocus = this.state.hasFocus;
      return /*#__PURE__*/React.createElement(MultiDownshift, {
        onChange: handleChange,
        itemToString: this.itemToString
      }, function (_ref) {
        var getInputProps = _ref.getInputProps,
            getToggleButtonProps = _ref.getToggleButtonProps,
            getMenuProps = _ref.getMenuProps,
            getRemoveButtonProps = _ref.getRemoveButtonProps,
            removeItem = _ref.removeItem,
            isOpen = _ref.isOpen,
            inputValue = _ref.inputValue,
            selectedItems = _ref.selectedItems,
            getItemProps = _ref.getItemProps,
            highlightedIndex = _ref.highlightedIndex,
            toggleMenu = _ref.toggleMenu;

        var dropdownOnClickKeypressHandler = function dropdownOnClickKeypressHandler() {
          toggleMenu();

          if (!isOpen) {
            _this2.input.current.focus();
          }
        };

        return /*#__PURE__*/React.createElement("div", {
          className: _this2.getClassName()
        }, /*#__PURE__*/React.createElement("div", {
          className: _this2.getClassName({
            descendantName: "dropdown",
            states: classNames({
              open: isOpen,
              focus: hasFocus,
              populated: selectedItems.length > 0
            })
          }),
          onClick: dropdownOnClickKeypressHandler,
          onKeyPress: dropdownOnClickKeypressHandler,
          role: "listbox",
          "data-testid": "dropdown"
        }, /*#__PURE__*/React.createElement("div", {
          className: _this2.getClassName({
            descendantName: "inner"
          })
        }, selectedItems.length > 0 || inputValue ? selectedItems.map(function (item) {
          return /*#__PURE__*/React.createElement("div", {
            key: item.value,
            className: _this2.getClassName({
              descendantName: "multiValue"
            }),
            "data-testid": "multiValue"
          }, /*#__PURE__*/React.createElement("div", {
            className: _this2.getClassName({
              descendantName: "multiValueInner"
            })
          }, /*#__PURE__*/React.createElement("button", getRemoveButtonProps({
            item: item,
            className: _this2.getClassName({
              descendantName: "multiValueClose"
            }),
            "data-testid": "multiValueClose"
          }), /*#__PURE__*/React.createElement(UiCross, {
            height: 18,
            width: 18
          })), /*#__PURE__*/React.createElement("span", {
            className: _this2.getClassName({
              descendantName: "multiValueLabel"
            })
          }, item.label)));
        }) : /*#__PURE__*/React.createElement("span", {
          className: _this2.getClassName({
            descendantName: "placeholder"
          })
        }, placeholder), /*#__PURE__*/React.createElement(AutosizeInput, getInputProps({
          ref: _this2.input,
          onKeyUp: function onKeyUp(event) {
            if (event.key === "Backspace" && !inputValue) {
              removeItem(selectedItems[selectedItems.length - 1]);
            }
          },
          onFocus: function onFocus() {
            return _this2.setState({
              hasFocus: true
            });
          },
          onBlur: function onBlur() {
            return _this2.setState({
              hasFocus: false
            });
          },
          inputClassName: _this2.getClassName({
            descendantName: "input"
          }),
          "data-input": "autosize",
          "data-testid": "textInput",
          id: name,
          value: inputValue || ""
        }))), /*#__PURE__*/React.createElement("button", _extends({}, getToggleButtonProps({
          // prevents the menu from immediately toggling
          // closed (due to our custom click handler above).
          onClick: function onClick(event) {
            event.stopPropagation();
          }
        }), {
          className: _this2.getClassName({
            descendantName: "controllerButton"
          }),
          "data-testid": "controllerButton"
        }), /*#__PURE__*/React.createElement("span", {
          className: _this2.getClassName({
            descendantName: "controllerArrow",
            states: classNames({
              open: isOpen
            })
          })
        }, /*#__PURE__*/React.createElement(ChevronDown, {
          height: 28,
          width: 28
        })))), /*#__PURE__*/React.createElement("ul", _extends({}, getMenuProps(), {
          className: _this2.getClassName({
            descendantName: "menu",
            states: classNames({
              open: isOpen
            })
          }),
          "data-testid": "menu"
        }), isOpen ? function () {
          var items = getItems({
            options: options,
            filter: inputValue
          });
          return items.length ? items.map(function (item, index) {
            return /*#__PURE__*/React.createElement("li", _extends({
              key: item.value
            }, getItemProps({
              item: item,
              index: index
            }), {
              className: _this2.getClassName({
                descendantName: "item",
                states: classNames({
                  active: highlightedIndex === index,
                  selected: selectedItems.some(function (i) {
                    return _this2.itemToString(i) === _this2.itemToString(item);
                  })
                })
              }),
              "data-testid": "menuItem"
            }), item.label);
          }) : /*#__PURE__*/React.createElement("li", {
            className: _this2.getClassName({
              descendantName: "noOptionsMessage"
            }),
            "data-testid": "noOptionsMessage"
          }, noOptionsMessage);
        }() : null));
      });
    }
  }]);

  return MultiSelectDropdown;
}(React.Component);

MultiSelectDropdown.displayName = "MultiSelectDropdown";
MultiSelectDropdown.propTypes = {
  /**
   * On change event handler
   */
  handleChange: PropTypes.func.isRequired,

  /**
   * Text input name/id
   */
  name: PropTypes.string.isRequired,

  /**
   * Message displayed in the filter if there is no option resulting from the typeahead input
   */
  noOptionsMessage: PropTypes.string.isRequired,

  /**
   * Data to generate listed options
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),

  /**
   * Placeholder for the filter input
   */
  placeholder: PropTypes.string.isRequired
};
export default MultiSelectDropdown;